var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-1 right-bar",class:{
        'dark-theme': _vm.$vuetify.theme.dark,
        'white-theme': !_vm.$vuetify.theme.dark
    }},[(
            _vm.selectedBetfairId.betfairId ||
            _vm.selectedBetfairId.id ||
            _vm.selectedBetfairId.marketId
        )?_c('bet-popover',{class:{ 'shake-now': _vm.shake },attrs:{"check-id":_vm.selectedBetfairId.betfairId ||
            _vm.selectedBetfairId.id ||
            _vm.selectedBetfairId.marketId},on:{"getPopoverHeight":_vm.getPopoverHeight}}):_vm._e(),_vm._v(" "),_c('div',[(_vm.isPageLoaded)?_c('my-bets',{staticClass:"hits-sticky",attrs:{"show-live":_vm.showLive,"show-score":_vm.showScore,"tv-score-position-switch":_vm.tvScorePositionSwitch,"popover-height":_vm.popoverHeight}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }